/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-shadow */

import { add } from 'date-fns';
import differenceInDays from 'date-fns/differenceInDays';
import { chunk, isEmpty } from 'lodash-es';

import apiUrls from '@/apiUrls.config';
import initRouteInfo from '@/helper-functions/route-info/init-route-info';
import zmianaSortowaniaClicked from '~/googleTagManager/listing/zmiana-sortowania-clicked';
import { czyJestRoute } from '~/modules/routing';
import { fetchMainDescription, fetchOpinie } from '~/modules/seo';
import {
  fetchBloczekWhenNewMarkers,
  parseWyszukajBody,
  fetchBloczkiPierwszaStrona,
  saveSearchHistory,
  setParams,
  parseDatesOfBirth,
  createParamsWidgetSzukaj,
} from '~/storeServices/szukaj';

import { makeMutations } from '../helper-functions/store/store';

const queryString = require('query-string');

export const state = () => ({
  wyniki: [],
  widgetTerminy: [],
  userIntrestedInTerminAsc: false,
  lastSearchedDateTerminy: null,
  dataWylotu: [],
  count: 0,
  czyCenaZaOsobe: true,
  sortowanie: null,
  bloczki: [],
  activeMarkerBloczek: null,
  currentPage: 0,
  bloczkiPerPage: 10,
  wybrane: {
    sortowanie: null,
  },
  ostatnieWyszukiwania: [],
  sekcjaSeo: null,
  isFromCrawler: false,
  defaultBreadcrumbs: [
    {
      Nazwa: 'Rainbow',
      Url: '/',
    }, {
      Nazwa: 'Wyniki wyszukiwania',
      Url: '',
    },
  ],
  routeInfo: initRouteInfo(),
  lastRouteInfoChange: null,
  loadedBloczki: false,
  loadedWidgetLastminute: false,
  paramsUrl: {},
  popularnyKierunek: null,
  shownComponent: 'bloczki',
  wyszukajBody: {},
  slowaKluczoweRouting: {},
  iloscZaczytanychBloczkowOstatniRequest: 0,
  lastCall: 0, // TODO (FIX NA SZYBKO)
});
export const mutations = {
  ...makeMutations([
    'sortowanie',
    'wyniki',
    'count',
    'loadedBloczki',
    'loadedWidgetLastminute',
    'currentPage',
    'bloczki',
    'paramsUrl',
    'shownComponent',
    'popularnyKierunek',
    'wyszukajBody',
    'slowaKluczoweRouting',
    'widgetTerminy',
    'lastSearchedDateTerminy',
    'dataWylotu',
    'iloscZaczytanychBloczkowOstatniRequest',
  ]),
  lastCall(state, value) {
    state.lastCall = value;
  },
  changeSortowanie(state, newValue) {
    state.wybrane.sortowanie = newValue;
  },
  setWyniki(state, newValue) {
    state.count = newValue.Count;
    state.wyniki = newValue.Wynik;
    state.czyCenaZaOsobe = newValue.CzyCenaZaOsobe;
  },
  appendBloczki(state, payload) {
    state.bloczki = [...state.bloczki, ...payload];
  },
  setCurrentPage(state) {
    state.currentPage += 1;
  },
  setBloczek(state, newValue) {
    state.activeMarkerBloczek = newValue;
  },
  setOstatnieWyszukiwania(state, payload) {
    state.ostatnieWyszukiwania = payload;
  },
  setSectionSeo(state, payload) {
    state.sekcjaSeo = payload;
  },
  isFromCrawler(state, payload) {
    state.isFromCrawler = payload;
  },
  routeInfo(state, payload) {
    state.routeInfo = payload;
  },
  appendOpinions(state, payload) {
    state.sekcjaSeo.opinionResponse = [...state.sekcjaSeo.opinionResponse, ...payload];
    state.sekcjaSeo.opinionPage++;
  },
  wyczyscSekcjeSeo(state) {
    const seo = {
      isLongSeo: false,
      mainDescription: null,
      opinionResponse: null,
    };

    state.sekcjaSeo = seo;
  },
  appendTerminyWidget(state, payload) {
    state.widgetTerminy.push(...payload);
    state.widgetTerminy.sort((a, b) => {
      const dateA = new Date(a.Termin);
      const dateB = new Date(b.Termin);

      return dateA - dateB;
    });
  },
  userIntrestedInTerminAsc(state, payload) {
    if (typeof payload !== 'boolean') {
      state.userIntrestedInTerminAsc = false;
      return;
    }

    if (payload) {
      state.userIntrestedInTerminAsc = payload;
      this.$cookies.set('userIntrestedInTerminAsc', payload);
    }
  },
};
export const getters = {
  ostatnieWyszukiwania(state) {
    return state.ostatnieWyszukiwania;
  },
  routeInfo(state) {
    return state.routeInfo;
  },
  defaultBreadcrumbs(state) {
    return state.defaultBreadcrumbs;
  },
  hasAtOneLeastWithCoords(state) {
    return state.wyniki && state.wyniki.find((x) => x.DlugoscGeo != null && x.SzerokoscGeo != null);
  },
  countWithCoords(state) {
    return !state.count || !state.wyniki ? 0 : state.wyniki.filter((x) => x.DlugoscGeo != null && x.SzerokoscGeo != null).length;
  },
  getWidgetTerminy(state) {
    return state.widgetTerminy;
  },
  shouldGetTerminyWidget(state, getters, rootState) {
    const showWidgetFromApi = state.routeInfo.Filtr.CzyWidgetTerminy !== undefined ? state.routeInfo.Filtr.CzyWidgetTerminy : false;
    const showWidgetBoczne = rootState.filtryBoczne.showWidgetLastMinute;
    const dataIsNull = rootState.filtry.data === null;

    return (showWidgetFromApi || showWidgetBoczne || state.userIntrestedInTerminAsc) && dataIsNull;
  },
  showTerminyWidget(state, getters) {
    return getters.shouldGetTerminyWidget && state.widgetTerminy.length > 0;
  },
};
export const actions = {
  async fetchSzukaj({
    commit, dispatch, rootState, rootGetters, state, getters,
  }, refreshWidget = true) {
    const diff = +new Date() - state.lastCall;
    let payload = null;

    payload = parseWyszukajBody(rootState);
    if (!payload || !payload.DatyUrodzenia?.length || !payload.AtrybutySingle?.Cena?.length) return;

    if (state.lastCall && diff < 500) {
      return;
    }

    await commit('lastCall', +new Date());

    try {
      await commit('loadedBloczki', false);
      await commit('currentPage', 0);
      const wyszukajData = await this.$http.$post(`${apiUrls.wyszukiwarka}wyszukaj`, payload);

      await commit('setWyniki', wyszukajData);
      await commit('wyszukajBody', payload);

      await fetchBloczekWhenNewMarkers(wyszukajData, dispatch, commit);
      await fetchBloczkiPierwszaStrona(wyszukajData, state.bloczkiPerPage, state.currentPage, dispatch, commit, payload);
      if (process.client) setParams(payload, rootState);

      // eslint-disable-next-line no-underscore-dangle
      const url = process.client ? null : this.app.$http._defaults.prefixUrl.slice(0, -1) + this.app.context.route.fullPath;

      await saveSearchHistory(wyszukajData, state.ostatnieWyszukiwania, payload, rootState, rootGetters, commit, dispatch, url);

      if (refreshWidget && getters.shouldGetTerminyWidget) {
        await commit('lastSearchedDateTerminy', null);
        await dispatch('fetchWidgetSzukaj');
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      commit('loadedBloczki', true);
    }
  },
  async fetchBloczek({ commit, rootState }, obj) {
    if (!obj) {
      commit('setBloczek', null);
      return;
    }

    const payload = parseWyszukajBody(rootState);

    if (!payload.DatyUrodzenia.length) {
      return;
    }

    const body = {
      DatyUrodzenia: payload.DatyUrodzenia,
      LiczbaPokoi: payload.LiczbaPokoi,
      Parametry: [obj],
      CzyCenaZaOsobe: rootState.szukaj.czyCenaZaOsobe,
    };
    const bloczekData = await this.$http.$post(`${apiUrls.bloczki}pobierz-bloczek`, body);

    await commit('setBloczek', bloczekData);
  },
  async fetchBloczki({ commit, rootState }, obj) {
    // console.log("🚀 ~ file: szukaj.js ~ line 139 ~ fetchBloczki ~ obj", obj)
    if (!obj) {
      commit('loadedBloczki', true);
      return;
    }

    const body = {
      DatyUrodzenia: obj.payload.DatyUrodzenia,
      LiczbaPokoi: obj.payload.LiczbaPokoi,
      Parametry: obj.pierwszaStrona,
      CzyCenaZaOsobe: rootState.szukaj.czyCenaZaOsobe,
    };
    const bloczkiData = await this.$http.$post(`${apiUrls.bloczki}pobierz-bloczki`, body);

    await commit('iloscZaczytanychBloczkowOstatniRequest', bloczkiData ? bloczkiData.length : 0);
    await commit('bloczki', bloczkiData);
    await commit('currentPage', 1);
    await commit('loadedBloczki', true);
  },
  async fetchMoreOffers({ commit, rootState, state }) {
    const datyUrodzenia = parseDatesOfBirth(rootState.filtry.datyUrodzenia);
    const parametry = chunk(state.wyniki, state.bloczkiPerPage)[state.currentPage];

    if (!datyUrodzenia && rootState.filtry.liczbaPokoi && !parametry) {
      return;
    }

    const body = {
      DatyUrodzenia: datyUrodzenia,
      LiczbaPokoi: rootState.filtry.liczbaPokoi,
      Parametry: parametry,
      CzyCenaZaOsobe: rootState.szukaj.czyCenaZaOsobe,
    };

    const bloczkiData = await this.$http.$post(`${apiUrls.bloczki}pobierz-bloczki`, body);

    await commit('iloscZaczytanychBloczkowOstatniRequest', bloczkiData ? bloczkiData.length : 0);
    await commit('appendBloczki', bloczkiData);
    await commit('setCurrentPage');
    return bloczkiData;
  },
  async fetchSort({ commit, state }) {
    if (state.wybrane.sortowanie !== null) {
      return;
    }

    const responseJson = await this.$http.$get(`${apiUrls.filtry}pobierz-dostepne-sortowania`);

    commit('sortowanie', responseJson);
    commit('changeSortowanie', responseJson[0]);
  },
  setSearchHistoryInCookie(context, payload) {
    // console.log("🚀 ~ file: szukaj.js ~ line 79 ~ setSearchHistoryInCookie ~ payload", payload)
    this.$cookies.set('searchHistory', payload, {
      expires: add(Date.now(), { years: 1 }),
    });
  },
  async setShownComponent({ commit, state }, payload) {
    commit('shownComponent', payload);

    const url = new URL(window.location.href);
    const queryStringParse = queryString.parse(url.search, { arrayFormat: 'bracket' });

    queryStringParse.widok = state.shownComponent === 'bloczki' ? 'list' : 'map';
    url.search = queryString.stringify(queryStringParse, { arrayFormat: 'bracket' });
    history.replaceState({}, null, url);
  },
  async fetchNextOpinions({ commit, state }) {
    const opinionResponse = await app.$http.$get(
      `https://rpl-api.r.pl/opinie/opinie-dla-lokalizacji/info-panstwo-region-opinie?nazwaPanstwaUrl=${
        routeInfo.Seo.PanstwoUrl
      }&nazwaRegionuUrl=${routeInfo.Seo.RegionUrl}&dopobrania=10&pobrane=${state.sekcjaSeo.opinionPage * 10}`,
    );

    commit('appendOpinions', opinionResponse);
  },
  changeSortowanie({ state, commit }, payload) {
    zmianaSortowaniaClicked();
    if (!state.userIntrestedInTerminAsc && payload.Klucz === 'termin-asc') {
      commit('userIntrestedInTerminAsc', true);
    }

    commit('changeSortowanie', payload);
  },
  async setPolecaneKierunki({ commit }, payload) {
    await commit('popularnyKierunek', payload);
  },
  async czyJestRoute({ commit }, path) {
    const routeInfo = await czyJestRoute(this.$http, path);

    commit('routeInfo', routeInfo);
    return routeInfo;
  },
  async ustawSekcjeSeo({ commit }, payload) {
    if (isEmpty(payload) || payload?.Klucz === 'szukaj') return;

    const mainDescription = await fetchMainDescription(this.$http, {
      Route: payload.Route,
      Klucz: payload.Klucz,
      Seo: payload.Seo,
    });
    const opinionResponse = await fetchOpinie(this.$http, payload.Seo.PanstwoUrl, payload.Seo.RegionUrl);

    const seo = {
      isLongSeo: payload.Seo.PelneSeo,
      mainDescription,
      opinionResponse,
      opinionPage: 0,
    };

    commit('setSectionSeo', seo);
  },
  async fetchSlowaKluczowe({ commit }) {
    const responseData = await this.$http.$get(`${apiUrls.routing}/slowa-kluczowe?filtry=true`);

    commit('slowaKluczoweRouting', responseData);
  },
  async fetchWidgetSzukaj({
    commit, state, rootState, dispatch,
  }) {
    commit('loadedWidgetLastminute', false);
    const params = createParamsWidgetSzukaj(state, rootState, commit);
    const firstFetch = await this.$http.$post(`${apiUrls.wyszukiwarka}wyszukaj-ceny-termin`, params);

    commit('widgetTerminy', firstFetch);

    if (state.widgetTerminy.length < 7) {
      await dispatch('loadNextWidgetSzukaj');
    }

    commit('loadedWidgetLastminute', true);
  },
  async loadNextWidgetSzukaj({
    commit, state, rootState, dispatch,
  }) {
    const differenceToTerminMin = differenceInDays(state.lastSearchedDateTerminy, rootState.filtry.TerminMin);

    // 42dni = 6 tygodni = 1.5 miesiaca blokada aby nie szukac dalej terminow
    if (differenceToTerminMin > 42) {
      return;
    }

    const params = createParamsWidgetSzukaj(state, rootState, commit);

    const responseData = await this.$http.$post(`${apiUrls.wyszukiwarka}wyszukaj-ceny-termin`, params);

    commit('appendTerminyWidget', responseData);
    if (state.widgetTerminy.length < 7) {
      await dispatch('loadNextWidgetSzukaj');
    }
  },
  clearDataWylotu({ commit }) {
    commit('dataWylotu', []);
  },
};
